// The agent store — every agent the organisation has published.

import { AgentGrid } from "@/components/chat/agent-grid";

export default function ChatAgentsPage() {
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="mx-auto max-w-3xl px-4 py-10">
        <h1 className="mb-1 text-xl font-semibold">Agents</h1>
        <p className="mb-6 text-sm text-muted-foreground">
          Agents your organisation has published. Pick one to start a chat.
        </p>
        <AgentGrid />
      </div>
    </div>
  );
}
